// Is a given variable an object?
export default function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isObject.js
// module id = 50
// module chunks = 0 1